import Reveal from "@/components/base/Reveal";
import SectionHeading from "@/components/base/SectionHeading";
import { timeline } from "@/mocks/timeline";

export default function TimelineSection() {
  return (
    <section id="timeline" className="border-y border-background-200 bg-background-100 py-14 md:py-20">
      <div className="mx-auto w-full max-w-[1240px] px-4 md:px-6">
        <Reveal>
          <SectionHeading
            eyebrow="事件时间线"
            title="按时间顺序，把假期八天串成一条线"
            desc="从调休讨论到返程高峰，用一条时间线还原假期话题的推进节奏。每一条都标注了所属主题，点击分类可查看同类内容。"
          />
        </Reveal>

        <ol className="mt-8 space-y-4">
          {timeline.map((item, index) => (
            <Reveal key={item.date} delay={index * 40}>
              <li className="grid grid-cols-1 gap-4 rounded-lg border border-background-200 bg-background-50 p-5 transition-colors hover:border-primary-300 md:grid-cols-12 md:items-start md:gap-6 md:p-6">
                <div className="flex items-center gap-3 md:col-span-3">
                  <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-md bg-accent-500 font-heading text-lg font-bold text-primary-950">
                    {index + 1}
                  </span>
                  <div>
                    <div className="font-heading text-base font-bold text-foreground-950">{item.date}</div>
                    <div className="text-xs text-foreground-500">{item.day}</div>
                  </div>
                </div>
                <div className="md:col-span-9 md:border-l md:border-background-200 md:pl-6">
                  <span className="inline-flex rounded-full bg-secondary-100 px-2.5 py-1 text-xs font-medium text-secondary-800">
                    {item.topic}
                  </span>
                  <h3 className="mt-2.5 font-heading text-lg font-bold text-foreground-950">{item.title}</h3>
                  <p className="mt-2 text-sm leading-relaxed text-foreground-600">{item.desc}</p>
                </div>
              </li>
            </Reveal>
          ))}
        </ol>
      </div>
    </section>
  );
}